"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addConsignmentAttachmentDetailSchema = exports.AddRemoveTagDetailDetailSchema = exports.AddTokenIdDetailSchema = exports.TransferConsignmentDetailSchema = exports.CompleteConsignmentDetailSchema = exports.SubmitConsignmentDetailSchema = exports.AddConsignmentSettingActivityDetailSchema = exports.DeactivateUserActivityDetailSchema = exports.InviteUserActivityDetailSchema = exports.JoinBusinessActivityDetailSchema = exports.EditPluginActivityDetailSchema = exports.DeactivatePluginActivityDetailSchema = exports.ActivatePluginActivityDetailSchema = exports.GenerateCodeActivityDetailSchema = exports.StatusActivityDetailSchema = exports.OutConsignmentDetailSchema = exports.LinkProductActivityDetailSchema = exports.AngusAIJoiningActivityDetailSchema = exports.TransTokenActivityDetailSchema = exports.DelTokenActivityDetailSchema = exports.ReplaceTagActivityDetailSchema = exports.UploadCsvActivityDetailSchema = exports.HeightActivityDetailSchema = exports.TreatmentActivityDetailSchema = exports.DeceaseActivityDetailSchema = exports.PregnancyActivityDetailSchema = exports.WeightActivityDetailSchema = exports.MovementActivityDetailSchema = exports.UpdateUserActivitySchema = exports.TokenDetailsSchema = exports.ActivityTypeSchema = void 0;
const zod_1 = require("zod");
const Token = __importStar(require("../model/token"));
const user = __importStar(require("../misc/user"));
const BusinessMisc = __importStar(require("../misc/business"));
const AngusMobMisc = __importStar(require("../misc/angusMob"));
const AngusSireMisc = __importStar(require("../misc/angusSire"));
const TokenMisc = __importStar(require("../misc/token"));
const LocationMisc = __importStar(require("../misc/location"));
const ConsginmentMisc = __importStar(require("../misc/consignment"));
const credential_1 = require("../misc/credential");
exports.ActivityTypeSchema = zod_1.z.enum(["UP_user_details", "UP_details", "DEL_details", "addMovement", "updateWeight",
    "updatePregnancyStatus", "updateDeceaseStatus", "addTreatment", "updateHeight", "uploadcsv", "replace_tag", "DEL_token",
    "TRANS_token", "angusAIJoining", "linkProduct", "outConsignment", "updateStatus", "generateSecurityCode", "activatePlugin",
    "deactivatePlugin", "editPlugin", "join_business", "invite_user", "deactivate_user", "activate_user", "submitConsignment",
    "completeConsignment", "transferConsignment", "addTokenId", "linkToken", "move", "transfer", "addConsignmentSetting", "addTraits",
    "modify_details", "add_tag", "remove_tag", "addConsignmentAttachment"]);
//detail reference for up_details and del_details
exports.TokenDetailsSchema = zod_1.z.object({
    name: zod_1.z.string().optional(),
    emailAddress: user.UserSchema.optional(),
    mobileNumber: user.PhoneNumberSchema.optional(),
    role: zod_1.z.string().optional(),
    location: zod_1.z.array(BusinessMisc.LocationSchema).optional(),
    tagAlertStandard: BusinessMisc.TagAlertStandardSchema.optional(),
    isAngusMob: zod_1.z.boolean().optional(),
    calves: AngusMobMisc.CalveTransactionSchema.optional(),
    group_sires: zod_1.z.array(AngusSireMisc.GroupSiresSchema).optional(),
    isAngusSireGroup: zod_1.z.boolean().optional(),
    businessId: zod_1.z.string().optional(),
    signature: zod_1.z.string().optional(),
    rfid: zod_1.z.string().optional(),
    nlis_id: zod_1.z.string().optional(),
    optiweigh: zod_1.z.object({
        clientId: zod_1.z.string(),
        agliveKey: zod_1.z.string(),
        apiKey: zod_1.z.string(),
        interval: zod_1.z.string(),
    }).optional(),
    country: zod_1.z.string().optional(),
    agliveInternalCall: zod_1.z.boolean().optional(),
    devices: LocationMisc.deviceDataSchema.optional()
});
//update user details activity details
exports.UpdateUserActivitySchema = zod_1.z.object({
    userId: zod_1.z.string(),
    name: user.NameSchema,
    phone: user.PhoneNumberSchema,
    email: user.EmailSchema,
    country: zod_1.z.string(),
});
//movement activty details
exports.MovementActivityDetailSchema = zod_1.z.object({
    site_moved_to: zod_1.z.string(),
    site_moved_to_region: zod_1.z.string().optional(),
    site_moved_to_property_type: zod_1.z.string().optional(),
    site_moved_from: zod_1.z.string(),
    site_moved_from_property_type: zod_1.z.string().optional(),
    site_moved_from_region: zod_1.z.string().optional(),
    pic_id_moved_to: zod_1.z.string(),
    pic_name_moved_to: zod_1.z.string(),
    move_date: zod_1.z.date(),
});
//weight activity detail
exports.WeightActivityDetailSchema = zod_1.z.object({
    visual_tag: zod_1.z.string().optional(),
    society_number: zod_1.z.string().optional(),
    stud_id: zod_1.z.string().optional(),
    additional_tag: zod_1.z.string().optional(),
    external_identify: zod_1.z.string().optional(),
    unit: zod_1.z.union([zod_1.z.literal('KG'), zod_1.z.literal('LBS')]),
    weight: zod_1.z.number(),
    date_of_weight: zod_1.z.string(),
});
//pregnant activity detail
exports.PregnancyActivityDetailSchema = zod_1.z.object({
    visual_tag: zod_1.z.string().optional(),
    society_number: zod_1.z.string().optional(),
    stud_id: zod_1.z.string().optional(),
    additional_tag: zod_1.z.string().optional(),
    external_identify: zod_1.z.string().optional(),
    birth_productivity: zod_1.z.any().optional(),
    conceptioninsemination: zod_1.z.unknown(),
    conception_rate: zod_1.z.unknown().optional(),
    conception_status: zod_1.z.string().optional(),
    conception_method: zod_1.z.string().optional(),
    appraised_by: zod_1.z.string().optional(),
    appraisal_test: zod_1.z.string().optional(),
    joined_date: zod_1.z.string().optional(),
    progeny_number: zod_1.z.number().optional(),
    progeny_dam_identity: zod_1.z.string().optional(),
    progeny_sire_identity: zod_1.z.string().optional(),
    date_of_birth: zod_1.z.string().optional(),
    progeny_birth_weight: zod_1.z.number().optional(),
    progeny_gender: zod_1.z.string().optional(),
    joined_due_date: zod_1.z.string().optional(),
    joined_due_dateseason: zod_1.z.string().optional(),
});
//decrease activity detail
exports.DeceaseActivityDetailSchema = zod_1.z.object({
    visual_tag: zod_1.z.string().optional(),
    society_number: zod_1.z.string().optional(),
    stud_id: zod_1.z.string().optional(),
    additional_tag: zod_1.z.string().optional(),
    external_identify: zod_1.z.string().optional(),
    death_reason: zod_1.z.string().optional(),
    deceased_date: zod_1.z.string().optional(),
    disposal_method: zod_1.z.string().optional(),
});
//treatment activity detail
exports.TreatmentActivityDetailSchema = zod_1.z.object({
    visual_tag: zod_1.z.string().optional(),
    society_number: zod_1.z.string().optional(),
    stud_id: zod_1.z.string().optional(),
    additional_tag: zod_1.z.string().optional(),
    external_identify: zod_1.z.string().optional(),
    product_name: zod_1.z.string(),
    product_number: zod_1.z.string(),
    esi: zod_1.z.number().optional(),
    whp: zod_1.z.number().optional(),
    treatment_date: zod_1.z.string().optional(),
    treated_by: zod_1.z.string(),
    batch_number: zod_1.z.number(),
    batch_expiry_date: zod_1.z.string().optional(),
    dose: zod_1.z.number().optional(),
    dose_unit: zod_1.z.string().optional(),
    dose_ratio: zod_1.z.number().optional(),
    reason_for_treatment: zod_1.z.string().optional(),
    ec_value: zod_1.z.number().optional(),
    ph_value: zod_1.z.number().optional(),
});
//height activity details
exports.HeightActivityDetailSchema = zod_1.z.object({
    unit: zod_1.z.enum(['CM', 'INCH']),
    height: zod_1.z.number(),
    date_of_height: zod_1.z.string()
});
//upload csv activity details
exports.UploadCsvActivityDetailSchema = zod_1.z.object({
    csvType: zod_1.z.string(),
    tokenAmount: zod_1.z.number(),
    filename: zod_1.z.string(),
    csvlink: zod_1.z.string(),
    createdAt: zod_1.z.date()
});
//replace tag activity details
exports.ReplaceTagActivityDetailSchema = zod_1.z.object({
    replaceMLATags: zod_1.z.boolean().default(true).optional(),
    rfid: zod_1.z.string().optional(),
    tag_type: zod_1.z.string().optional(),
    ceres_tag_vid: zod_1.z.string().optional(),
    original_ceres_tag_vid: zod_1.z.string().optional(),
});
//del token activity details
exports.DelTokenActivityDetailSchema = zod_1.z.object({
    reason: zod_1.z.string()
});
//trans token activity details
exports.TransTokenActivityDetailSchema = zod_1.z.object({
    receiverName: zod_1.z.string(),
    receiverId: zod_1.z.string(),
    receiverBusiness: BusinessMisc.GeneralBusinessDetailSchema,
    receiverLocation: BusinessMisc.LocationSchema,
    senderName: zod_1.z.string(),
    senderBusiness: BusinessMisc.GeneralBusinessDetailSchema,
    senderLocation: BusinessMisc.LocationSchema,
    timestamp: zod_1.z.string()
});
//Angus AI Joining Activity details
exports.AngusAIJoiningActivityDetailSchema = zod_1.z.object({
    product: zod_1.z.object({
        calving_year: zod_1.z.number(),
        count: zod_1.z.number()
    })
});
//link product activity details
exports.LinkProductActivityDetailSchema = zod_1.z.object({
    product: zod_1.z.object({
        tokenId: zod_1.z.string(),
        externalIds: TokenMisc.ExternalIdsSchema
    })
});
//out consignment activity details
exports.OutConsignmentDetailSchema = ConsginmentMisc.ConsignmentDetailSchema.omit({
    submit: true,
    declaration: true,
    senderInfo: true
}).merge(zod_1.z.object({
    sender: zod_1.z.object({
        name: zod_1.z.string(),
        companyName: zod_1.z.string(),
    }),
    receiver: zod_1.z.object({
        name: zod_1.z.string(),
    })
}));
//status activity details
exports.StatusActivityDetailSchema = zod_1.z.object({
    date: zod_1.z.date(),
    status: zod_1.z.string(),
    who_sold_to: zod_1.z.string().optional(),
    reason: zod_1.z.string().optional()
});
//generate security code activity details
exports.GenerateCodeActivityDetailSchema = zod_1.z.object({
    securityCodeType: Token.securityCodeType,
    quantity: zod_1.z.number(),
    product: TokenMisc.ExternalIdsSchema,
    showDeliveryHistory: zod_1.z.boolean(),
    showMap: zod_1.z.boolean(),
    isConfidential: zod_1.z.boolean(),
    date: zod_1.z.date(),
    source: zod_1.z.object({
        companyName: zod_1.z.string(),
        companyNumber: zod_1.z.string(),
        creatorEmail: zod_1.z.string()
    })
});
//activate plugin activity
exports.ActivatePluginActivityDetailSchema = zod_1.z.object({
    uuid: zod_1.z.string(),
    credentials: credential_1.CredentialSchema
});
//deactivate plugin activity
exports.DeactivatePluginActivityDetailSchema = zod_1.z.object({
    uuid: zod_1.z.string()
});
//edit plugin activity
exports.EditPluginActivityDetailSchema = zod_1.z.object({
    uuid: zod_1.z.string(),
    credentials: credential_1.CredentialSchema,
    schedule: zod_1.z.string(),
    status: zod_1.z.enum(["activated", "deactivated"])
});
//join business activity
exports.JoinBusinessActivityDetailSchema = zod_1.z.object({
    invitationCode: zod_1.z.string()
});
//invite user activity
exports.InviteUserActivityDetailSchema = zod_1.z.object({
    name: zod_1.z.string(),
    role: zod_1.z.string(),
    phone: zod_1.z.string(),
    email: zod_1.z.string(),
    invitationDate: zod_1.z.date(),
    invitationCode: zod_1.z.string(),
    exiryTime: zod_1.z.date()
});
//deactivate user activity
exports.DeactivateUserActivityDetailSchema = zod_1.z.object({
    userId: zod_1.z.string()
});
//add Consignment Setting
const EnvdAnswerSchema = zod_1.z.object({
    answers: zod_1.z.object({
        title: zod_1.z.literal("Answers"),
        value: zod_1.z.enum(["No", "Yes"])
    })
});
exports.AddConsignmentSettingActivityDetailSchema = zod_1.z.object({
    consignee: zod_1.z.object({
        receiverName: zod_1.z.string(),
        receiverAddress: zod_1.z.string(),
        receiverPostCode: zod_1.z.string(),
        receiverLocation: zod_1.z.string(),
        receiverTown: zod_1.z.string(),
        receiverState: zod_1.z.string(),
        receiverPIC: zod_1.z.string()
    }),
    envdData: zod_1.z.object({
        envd: zod_1.z.object({
            id: zod_1.z.number(),
            name: zod_1.z.string(),
            template: zod_1.z.string(),
            properties: zod_1.z.object({
                questionnaire: zod_1.z.object({
                    Q1: EnvdAnswerSchema,
                    Q2: EnvdAnswerSchema,
                    Q3: EnvdAnswerSchema,
                    Q4: EnvdAnswerSchema,
                    Q5: EnvdAnswerSchema,
                    Q6: EnvdAnswerSchema,
                    Q7: EnvdAnswerSchema,
                    Q8: EnvdAnswerSchema,
                    Q9: EnvdAnswerSchema,
                })
            })
        }),
        hd: zod_1.z.string().nullable()
    }),
    locationData: BusinessMisc.LocationSchema
});
exports.SubmitConsignmentDetailSchema = zod_1.z.object({
    consignee: ConsginmentMisc.ConsigneeSchema.optional(),
    attachments: zod_1.z.array(zod_1.z.object({
        url: zod_1.z.string()
    })),
    shareTo: zod_1.z.object({
        sms: zod_1.z.array(zod_1.z.string()),
        email: zod_1.z.array(zod_1.z.string()),
    }),
    receiver: zod_1.z.object({
        userId: zod_1.z.string(),
        businessId: zod_1.z.string()
    }).optional(),
    sender: zod_1.z.object({
        name: zod_1.z.string(),
        companyName: zod_1.z.string(),
    }).optional()
});
exports.CompleteConsignmentDetailSchema = zod_1.z.object({
    type: zod_1.z.enum(["envd", "animal"]),
    completedAt: zod_1.z.union([zod_1.z.date(), zod_1.z.string()])
});
exports.TransferConsignmentDetailSchema = zod_1.z.object({
    receiverName: zod_1.z.string(),
    receiverId: zod_1.z.string(),
    receiverBusinessId: zod_1.z.string(),
    sender: zod_1.z.object({
        name: zod_1.z.string(),
        companyName: zod_1.z.string(),
    })
});
exports.AddTokenIdDetailSchema = zod_1.z.object({
    tokenId: zod_1.z.string(),
    transactionId: zod_1.z.string(),
    transactionTime: zod_1.z.union([zod_1.z.date(), zod_1.z.string()])
});
exports.AddRemoveTagDetailDetailSchema = zod_1.z.object({
    tag_type: zod_1.z.string(),
    ceres_tag_vid: zod_1.z.string()
});
exports.addConsignmentAttachmentDetailSchema = zod_1.z.object({
    agliveToken: zod_1.z.string(),
    attachments: zod_1.z.array(zod_1.z.string())
});
